import React from 'react';
import PropTypes from 'prop-types';
import CreditCardOfferHolder from 'partial/OfferManager/holder/CreditCardOfferHolder';
import CarouselCreditCardOffer from 'components/Offers/CarouselCreditCard';
import PersonalLoanOfferHolder from 'partial/OfferManager/holder/PersonalLoanOfferHolder';
import AutoLoanOfferHolder from 'partial/OfferManager/holder/AutoLoanOfferHolder';
import { BusinessLoanOfferHolder } from 'partial/OfferManager/holder/BusinessLoanOfferHolder';
import { StandardPersonalLoanOffer } from 'components/Offers/StandardPersonalLoanOffer';
import { PersonalLoanPrequalOffer } from 'components/Offers/PersonalLoanPrequalOffer';
import { StandardAutoLoanOffer } from 'components/Offers/StandardAutoLoanOffer';
import StandardAutoInsuranceOffer from 'components/Offers/StandardAutoInsuranceOffer/StandardAutoInsuranceOffer';
import StandardLifeInsuranceOffer from 'components/Offers/StandardLifeInsuranceOffer/StandardLifeInsuranceOffer';
import HomeInsuranceRedesignOffer from 'components/Offers/HomeInsuranceRedesignOffer/HomeInsuranceRedesignOffer';
import CreditRepairOfferHolder from 'partial/OfferManager/holder/CreditRepairOfferHolder';
import CreditRepairOffer from 'components/Offers/CreditRepair';
import {
  CREDIT_CARD_OFFER,
  PERSONAL_LOAN_OFFER,
  SEE_ALL_CARDS,
  BUSINESS_LOAN_OFFER,
  AUTO_INSURANCE,
  LIFE_INSURANCE,
  HOME_INSURANCE,
} from 'partial/OfferManager/offer.constants';
import FeaturedAd from 'partial/FeaturedAd';
import { HomeLoanOfferHolder } from 'partial/OfferManager/holder/HomeLoanOfferHolder';
import { StandardHomeLoanOffer } from 'components/Offers/StandardHomeLoanOffer';
import { StandardBusinessLoanOffer } from 'components/Offers/StandardBusinessLoanOffer';
import DebtReliefOfferHolder from 'partial/OfferManager/holder/DebtReliefOfferHolder';
import DebtReliefOffer from 'components/Offers/DebtReliefOffer';
import AutoInsuranceOfferHolder from 'partial/OfferManager/holder/AutoInsuranceOfferHolder';
import LifeInsuranceOfferHolder from 'partial/OfferManager/holder/LifeInsuranceOfferHolder';
import HomeInsuranceOfferHolder from 'partial/OfferManager/holder/HomeInsuranceOfferHolder';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';

const buildDataTestId = (options, i, type) => {
  if (options && options.datatestid) {
    return `${options.datatestid}-${i}-${type}`;
  } else {
    return `${i}-${type}`;
  }
};
const renderOffer = (offer, k, extraProps, options) => {
  const finalOpts = options ? options : {};
  if (!offer) {
    return '';
  } else if (offer.offerType === CREDIT_CARD_OFFER) {
    const template = finalOpts.creditCardTemplate
      ? finalOpts.creditCardTemplate
      : CarouselCreditCardOffer;
    const datatestid = buildDataTestId(options, k, 'card');
    return (
      <CreditCardOfferHolder
        creditCardTemplate={template}
        offerMetadata={offer}
        position={k + 1}
        key={k}
        {...extraProps}
        {...options}
        datatestid={datatestid}
      />
    );
  } else if (offer.offerType === PERSONAL_LOAN_OFFER) {
    const datatestid = buildDataTestId(options, k, 'pl');
    let template = finalOpts.personalLoanTemplate
      ? finalOpts.personalLoanTemplate
      : StandardPersonalLoanOffer;

    if (offer.isPrequalOffer) {
      template = PersonalLoanPrequalOffer;
    }

    return (
      <PersonalLoanOfferHolder
        {...extraProps}
        personalLoanTemplate={template}
        offerMetadata={offer}
        position={k + 1}
        key={k}
        {...options}
        datatestid={datatestid}
      />
    );
  } else if (offer.autoLoanRateUuid) {
    const datatestid = buildDataTestId(options, k, 'al');
    const template = finalOpts.autoLoanTemplate
      ? finalOpts.autoLoanTemplate
      : StandardAutoLoanOffer;

    return (
      <AutoLoanOfferHolder
        {...extraProps}
        autoLoanTemplate={template}
        offerMetadata={offer}
        position={k + 1}
        key={k}
        {...options}
        datatestid={datatestid}
      />
    );
  } else if (offer.creditRepairId) {
    const datatestid = buildDataTestId(options, k, 'cr');

    const template = finalOpts.creditRepairOfferTemplate
      ? finalOpts.creditRepairOfferTemplate
      : CreditRepairOffer;

    return (
      <CreditRepairOfferHolder
        creditRepairTemplate={template}
        offerMetadata={offer}
        datatestid={datatestid}
        position={k + 1}
        module={options ? options.module : null}
        key={k}
        {...extraProps}
        {...options}
      />
    );
  } else if (offer.type === SEE_ALL_CARDS) {
    return offer.component;
  } else if (offer.mortgageId !== undefined) {
    const template = finalOpts.homeLoanTemplate
      ? finalOpts.homeLoanTemplate
      : StandardHomeLoanOffer;

    return (
      <HomeLoanOfferHolder
        homeLoanTemplate={template}
        offerMetadata={offer}
        position={k + 1}
        key={k}
        {...extraProps}
        {...options}
      />
    );
  } else if (offer.debtReliefId) {
    const datatestid = buildDataTestId(options, k, 'debtRelief');
    return (
      <DebtReliefOfferHolder
        debtReliefTemplate={DebtReliefOffer}
        offerMetadata={offer}
        position={k + 1}
        key={k}
        {...extraProps}
        {...options}
        datatestid={datatestid}
      />
    );
  } else if (offer.offerType === AUTO_INSURANCE) {
    // TODO: change impressionId to offerType with SVC ticket
    const datatestid = buildDataTestId(options, k, 'autoInsurance');
    const template =
      finalOpts?.autoInsuranceTemplate || StandardAutoInsuranceOffer;
    return (
      <AutoInsuranceOfferHolder
        autoInsuranceTemplate={template}
        offerMetadata={offer}
        position={k + 1}
        key={k}
        {...extraProps}
        {...options}
        datatestid={datatestid}
      />
    );
  } else if (offer.offerType === LIFE_INSURANCE) {
    const datatestid = buildDataTestId(options, k, 'lifeInsurance');
    const template =
      finalOpts?.lifeInsuranceTemplate || StandardLifeInsuranceOffer;
    return (
      <LifeInsuranceOfferHolder
        lifeInsuranceTemplate={template}
        offerMetadata={offer}
        position={k + 1}
        key={k}
        {...extraProps}
        {...options}
        datatestid={datatestid}
      />
    );
  } else if (offer.offerType === HOME_INSURANCE) {
    const datatestid = buildDataTestId(options, k, 'homeInsurance');
    return (
      <HomeInsuranceOfferHolder
        homeInsuranceTemplate={HomeInsuranceRedesignOffer}
        offerMetadata={offer}
        position={k + 1}
        key={k}
        {...extraProps}
        {...options}
        datatestid={datatestid}
      />
    );
  } else if (offer.offerType === BUSINESS_LOAN_OFFER) {
    return (
      <BusinessLoanOfferHolder
        businessLoanTemplate={StandardBusinessLoanOffer}
        offerMetadata={offer}
        position={k + 1}
        key={k}
        {...extraProps}
        {...options}
      />
    );
  } else {
    return <div>default template{JSON.stringify(offer)}</div>;
  }
};

const createRenderedOfferComponents = (
  offerMetadataList,
  extraProps,
  options,
) => {
  if (offerMetadataList) {
    let finalMetadataList = offerMetadataList;
    if (!finalMetadataList.map) {
      return [];
    }

    return finalMetadataList?.map((offer, k) => {
      const featuredAd = options ? options.featuredAdProps : null;
      if (!featuredAd) {
        return renderOffer(offer, k, extraProps, options);
      } else {
        const finalBelowIndex =
          finalMetadataList.length - 1 < featuredAd.belowIndex
            ? finalMetadataList.length - 1
            : featuredAd.belowIndex;
        const hideAd = k !== finalBelowIndex;
        k = k > finalBelowIndex ? k + 1 : k; //increase index if it's higher than the featured ad index
        const offerContainerKey = offer.productKey ? offer.productKey : k;
        return (
          <FlexContainer
            key={offerContainerKey}
            className="format100 m-formatAuto flex-column"
          >
            {renderOffer(offer, k, extraProps, options)}
            <FeaturedAd
              location={featuredAd.location}
              position={featuredAd.position}
              hideAd={hideAd}
              customClass={featuredAd.customClass}
              offerPosition={k + 2}
              modulePosition={k + 2}
            />
          </FlexContainer>
        );
      }
    });
  }
};

class StaticOfferContainer extends React.Component {
  render() {
    const finalList = this.props.offerMetadataList
      ? this.props.offerMetadataList
      : [];
    const finalExtraTemplateProps = Object.assign(
      { eventHandler: this.props.eventHandler },
      this.props.templateProps,
    );
    return createRenderedOfferComponents(
      finalList,
      finalExtraTemplateProps,
      this.props,
    );
  }
}

StaticOfferContainer.propTypes = {
  offerMetadataList: PropTypes.array,
  extraEventAttributes: PropTypes.object,
  eventHandler: PropTypes.func,
};

StaticOfferContainer.createRenderedOfferComponents =
  createRenderedOfferComponents;

export default StaticOfferContainer;
